import { createContext } from 'react';

type FrequentlyBoughtTogetherContextProps = {
    products: Array<LP.product.ProductItem>,
    selectedProducts: Array<LP.product.ProductItem>,
    selectedProductsTotalPrice: number,
    selectedProductsCount: number,
    mainShortSku: string,
    selectProduct: (product: LP.product.ProductItem) => void,
    deselectProduct: (shortSku: string) => void
}

const FrequentlyBoughtTogetherContext = createContext<FrequentlyBoughtTogetherContextProps>(null);

export default FrequentlyBoughtTogetherContext;
